import React, { useState, useEffect, useMemo, useRef } from "react";
import SweetAlert from "react-bootstrap-sweetalert";
import Select from "react-select";
import { MultiSelect } from 'primereact/multiselect';
import 'primereact/resources/themes/lara-light-indigo/theme.css'; // theme
import 'primereact/resources/primereact.min.css';                 // core css
import 'primeicons/primeicons.css';                               // icons
import { AgGridReact } from 'ag-grid-react';
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import redirectURL from "../redirectURL";

const CycleDaysIndentation = () => {
    const [loadshow, setLoadshow] = useState("show-n");
    const [overlayBlock, setOverlayBlock] = useState("show-m");
    const [show, setShow] = useState(false);
    const [basicTitle, setBasicTitle] = useState("");
    const [basicType, setBasicType] = useState("default");
    const [rowData, setRowData] = useState([]);
    const [currentinvoiceDate, setCurrentInvoiceDate] = useState("");
    const [storeId, setStoreId] = useState({ label: "ALL", value: "" });
    const [storeOptions, setStoreOptions] = useState([{ label: "ALL", value: "" }]);
    const [destinationOptions, setDestinationOptions] = useState([]);

    const [isSliderOpen, setSliderOpen] = useState(false);
    const [sliderType, setSliderType] = useState(null);
    const [sliderCl, setSliderCl] = useState("");
    const [sliderTitle, setSliderTitle] = useState("");
    const [selectedDestinations, setSelectedDestinations] = useState([]);
    const [cycleStartDate, setCycleStartDate] = useState("");
    const [overlyBlock, setOverlyBlock] = useState("show-n");
    const [uploadedFileData, setUploadedFileData] = useState([]);
    
    const gridApi = useRef(null);
    const gridColumnApi = useRef(null);

    // Get today's date in YYYY-MM-DD format
    const getTodayDate = () => {
        const today = new Date();
        return today.toISOString().split('T')[0];
    };

    const getActiveDestinationoptions = async () => {
        try {
            const response = await redirectURL.post("masters/getActiveDestinations", {});
            
            if (response.data && response.data.status === "success") {
                const destinationData = response.data.data || [];
                
                const activeDestinations = destinationData
                    .filter(dest => dest.is_active === 1 || dest.is_active === true)
                    .map(dest => ({
                        value: dest.destination_store_id || dest._id,
                        label: `${dest.destination_store_id || dest.store_id} - ${dest.destination_store_name || dest.store_name}`
                    }));

                setDestinationOptions(activeDestinations);
            } else {
                console.warn("No active destination data found");
                setDestinationOptions([]);
            }
        } catch (error) {
            console.error("Error fetching destination master data:", error);
            setDestinationOptions([]);
        }
    };

    const onClickCycleBtn = async (event) => {
        try {
            setLoadshow("show-m");
            setOverlayBlock("show-m");
            
            await getActiveDestinationoptions();
            
            setSliderOpen(true);
            setSliderType(2);
            setSliderCl("slider-25");
            setSliderTitle("Create New Cycle");
            setCycleStartDate(getTodayDate());
            setSelectedDestinations([]);
            setOverlyBlock("show-m");
        } catch (error) {
            console.error("Error opening cycle slider:", error);
            setBasicTitle("Failed to load destination data");
            setBasicType("error");
            setShow(true);
        } finally {
            setLoadshow("show-n");
            setOverlayBlock("show-n");
        }
    };

    const handleDestinationChange = (event) => {
        const {
            target: { value },
        } = event;
        setSelectedDestinations(
            // On autofill we get a stringified value.
            typeof value === 'string' ? value.split(',') : value,
        );
    };

    const handleSelectAll = () => {
        if (selectedDestinations.length === destinationOptions.length) {
            setSelectedDestinations([]);
        } else {
            const allValues = destinationOptions.map(option => option.value);
            setSelectedDestinations(allValues);
        }
    };

    const handleCycleSubmit = async (e) => {
        e.preventDefault();
        
        try {
            if (selectedDestinations.length === 0) {
                setBasicTitle("Please select at least one destination");
                setBasicType("error");
                setShow(true);
                return;
            }

            if (!cycleStartDate) {
                setBasicTitle("Please select a start date");
                setBasicType("error");
                setShow(true);
                return;
            }

            setLoadshow("show-m");
            setOverlayBlock("show-m");

            const payload = {
                start_date: cycleStartDate,
                destinations: selectedDestinations
            };

            console.log("Sending payload:", payload);

            const response = await redirectURL.post("indentation/createCycle", payload);

            if (response.data && response.data.status === "success") {
                setBasicTitle("Cycle Dates Ran Successfully.");
                setBasicType("success");
                setShow(true);
                closeCycleSlider();
                getCycleDaysData(null);
            } else {
                throw new Error(response.data?.message || "Failed to create cycle");
            }

        } catch (error) {
            console.error("Error creating cycle:", error);
            setBasicTitle("Failed to create cycle");
            setBasicType("error");
            setShow(true);
        } finally {
            setLoadshow("show-n");
            setOverlayBlock("show-n");
        }
    };

    const closeCycleSlider = () => {
        setSliderOpen(false);
        setSliderType(null);
        setOverlyBlock("show-n");
    };

    const onClickingSliderCloseIcon = () => {
        setOverlyBlock("show-n");
        setSliderOpen(false);
        setSliderType(null);
        if (document.getElementById("bulkUploadFile")) {
            document.getElementById("bulkUploadFile").value = "";
        }
        setUploadedFileData([]);
    };

    const hideOverlySlideBlock = () => {
        setSliderOpen(false);
        setLoadshow("show-n");
        setOverlyBlock("show-n");
    };

    const columnWithDefs = [
        {
            headerName: "Calendar Date", 
            field: "calender_date", 
            sortable: true,
            valueGetter: (params) => {
                const date = new Date(params?.data?.calender_date) || "";
                if (!date) {
                    return ""
                } else {
                    return date.toISOString().split('T')[0] || "";
                }
            },
        },
        { headerName: "Day", field: "day", sortable: true },
        {
            headerName: "Is Holiday", 
            field: "is_holiday", 
            sortable: true,
            valueFormatter: (params) => params.value ? "Yes" : "No"
        },
        { headerName: "Is Wholesale Date", field: "is_wholesale_date", sortable: true },
        { headerName: "Destination Store ID", field: "destination_store_id", sortable: true },
        { headerName: "Destination Store Name", field: "destination_store_name", sortable: true },
        {
            headerName: "Is Cycle Date", 
            field: "is_cycle_date", 
            sortable: true,
            valueFormatter: (params) => params.value ? "Yes" : "No",
            cellStyle: (params) => {
                return {
                    color: params.value ? "green" : "red",
                    fontWeight: "bold"
                };
            }
        },
        { headerName: "Cycle Period (Days)", field: "cycle_period", sortable: true },
        { headerName: "Date", field: "date", sortable: true, hide: true },
        { headerName: "Month", field: "month", sortable: true },
        { headerName: "Year", field: "year", sortable: true },
        {
            headerName: "Inserted Date", 
            field: "inserted_date", 
            sortable: true, 
            filter: "agDateColumnFilter",
            valueFormatter: (params) => {
                const date = new Date(params.value);
                return date.toISOString().split('T')[0];
            },
            width: "160px", 
            flex: 1, 
            hide: true
        },
        {
            headerName: "Updated Date", 
            field: "updated_date", 
            sortable: true, 
            filter: "agDateColumnFilter",
            valueFormatter: (params) => {
                const date = new Date(params.value);
                return date.toISOString().split('T')[0];
            },
            width: "160px", 
            flex: 1, 
            hide: true
        }
    ];

    const sideBar = useMemo(() => ({
        toolPanels: [
            {
                id: "columns",
                labelDefault: "Columns",
                labelKey: "columns",
                iconKey: "columns",
                toolPanel: "agColumnsToolPanel",
            },
            {
                id: "filters",
                labelDefault: "Filters",
                labelKey: "filters",
                iconKey: "filter",
                toolPanel: "agFiltersToolPanel",
            },
        ]
    }), []);

    const statusPanel = {
        statusPanels: [
            {
                statusPanel: "agTotalAndFilteredRowCountComponent",
                align: "left"
            },
            {
                statusPanel: "agTotalRowCountComponent",
                align: "center"
            },
            { statusPanel: "agFilteredRowCountComponent" },
            { statusPanel: "agSelectedRowCountComponent" },
            { statusPanel: "agAggregationComponent" }
        ]
    }

    const defaultColDef = {
        sortable: true,
        minWidth: 150,
        filter: true,
        pivot: true,
        enableValue: true,
        enableRowGroup: true,
        resizable: true,
    }

    const onGridReady = (params) => {
        gridApi.current = params.api;
        gridColumnApi.current = params.columnApi;

        if (gridColumnApi.current) {
            const allColumns = gridColumnApi.current.getAllColumns();
            if (allColumns && allColumns.length > 0) {
                const allColumnIds = allColumns.map(col => col.getColId());
                gridColumnApi.current.autoSizeColumns(allColumnIds, false);
            }
        }
    };

    const onFirstDataRendered = (params) => {
        if (gridColumnApi.current) {
            const allColumns = gridColumnApi.current.getAllColumns();
            if (allColumns && allColumns.length > 0) {
                const allColumnIds = allColumns.map(col => col.getColId());
                gridColumnApi.current.autoSizeColumns(allColumnIds, false);
            }
        }
    };

    const getCycleDaysData = async (selectedDate = null) => {
        try {
            setLoadshow("show-m");
            setOverlayBlock("show-m");

            const params = selectedDate ? { calender_date: selectedDate } : {};
            const response = await redirectURL.post("indentation/getCycleDaysIndentationData", params);

            if (response.data && response.data.status === "success") {
            const cycleData = response.data.data.cycle_data;
            const destinationStoreIds = response.data.data.destinationStoreIds;

            const opts = [
                { value: "", label: "All" },
                ...destinationStoreIds.map(s => ({
                value: s.destination_store_id,
                label: `${s.destination_store_id} - ${s.destination_store_name}`,
                })),
            ];

            setRowData(cycleData);
            setStoreOptions(opts);
            setStoreId(opts[0]);                    // default to All

            // keep date empty when loading ALL
            if (selectedDate === null) setCurrentInvoiceDate("");
            }

            setLoadshow("show-n");
            setOverlayBlock("show-n");
        } catch (error) {
            console.error("Error fetching Cycle Days data:", error);
            setBasicTitle("Failed to fetch Cycle Days data");
            setBasicType("error");
            setShow(true);
        }
        };

    const getCycleFiltersDataIndentation = async () => {
        try {
            const params = {
            ...(currentinvoiceDate && { calender_date: currentinvoiceDate }),
            store_id: storeId ? storeId.value : ""
        };

            const response = await redirectURL.post("indentation/getCycleDaysIndentationData", params);
            
            if (response.data && response.data.status === 'success') {
                const cycleData = response.data.data.cycle_data;
                setRowData(cycleData);
                setLoadshow("show-n");
                setOverlayBlock("show-n");
            } else {
                setLoadshow("show-n");
                setOverlayBlock("show-n");
            }
        } catch (error) {
            console.error("Error fetching Cycle Days data:", error);
            setBasicTitle("Failed to fetch Cycle Days data");
            setBasicType("error");
            setShow(true);
        }
    };

    const closeAlert = () => {
        setShow(false);
        setLoadshow("show-n");
        setOverlayBlock("show-n");
    };

    const setfiltersData = async () => {
        setLoadshow("show-m");
        setOverlayBlock("show-m");
        await getCycleFiltersDataIndentation();
        setLoadshow("show-n");
        setOverlayBlock("show-n");
    };

    const resetFilters = () => {
        setCurrentInvoiceDate("");              
        setStoreId({ label: "All", value: "" }); 
        getCycleDaysData(null);                  
        };

    const handleDateChange = (date) => {
        // Only update the date state, don't fetch data
        setCurrentInvoiceDate(date);
    };

    useEffect(() => {
        setCurrentInvoiceDate("");        
        getCycleDaysData(null);          
    }, []);

    return (
        <>
            <div className="container-fluid mt-3">
                <div style={{ zIndex: "9999999" }}>
                    <SweetAlert
                        show={show}
                        type={basicType}
                        title={basicTitle}
                        onConfirm={closeAlert}
                        style={{ fontSize: "9px" }}
                    >
                    </SweetAlert>
                </div>

                <div className="row" style={{ fontSize: "0.9rem", fontFamily: "Arial, sans-serif" }}>
                    <div className="col-sm-12 p-0">
                        <h1 className="col-sm-12" style={{ color: "#B9366D", fontSize: "18px", fontWeight: "bold", fontFamily: "sans-serif" }}>
                            Cycle Dates
                        </h1>
                    </div>
                    
                    <form className="col-sm-12 p-0 mt-4 mb-4" style={{ display: "flex", alignItems: "center" }}>
                        <div className="col-sm-8 row ">
                            {/* Date Filter */}
                            <div className="col-sm-3 mb-1" style={{ display: "flex", flexDirection: "column" }}>
                                <label
                                    htmlFor="calendarDate"
                                    style={{ fontSize: "13px", fontWeight: "400" }}
                                >
                                    Calendar Date:
                                </label>
                                <input
                                    type="date"
                                    id="calendarDate"
                                    value={currentinvoiceDate || ""}
                                    onChange={(e) => handleDateChange(e.target.value)}
                                    style={{ 
                                        padding: "7px", 
                                        borderRadius: "5px", 
                                        border: "1px solid #d9d9d9", 
                                        width: "100%", 
                                        marginBottom: "15px", 
                                        cursor: "pointer" 
                                    }}
                                    onClick={() => document.getElementById('calendarDate').showPicker?.()}
                                />
                            </div>

                            {/* Store Filter */}
                            <div className="col-sm-3 mb-1" style={{ display: 'flex', flexDirection: 'column' }}>
                                <label htmlFor="storeId" style={{ fontSize: '13px', fontWeight: '400' }}>
                                    Destination Store ID:
                                </label>
                                <Select
                                    id="storeId"
                                    value={storeId}
                                    onChange={(selectedOption) => setStoreId(selectedOption)}
                                    options={storeOptions}
                                    styles={selectStyles}
                                />
                            </div>

                            <div className="ml-4 mt-4" style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "0px 10px" }}>
                                <button
                                    type="button"
                                    onClick={(e) => { e.preventDefault(); setfiltersData(); }}
                                    style={{
                                        backgroundColor: "#93385D",
                                        color: "#fff",
                                        borderRadius: "5px",
                                        padding: "8px 20px",
                                        border: "none",
                                        cursor: "pointer"
                                    }}
                                >
                                    Apply
                                </button>
                                <button
                                    onClick={(e) => { 
                                        e.preventDefault(); 
                                        resetFilters();
                                    }}
                                    type="button"
                                    style={{
                                        backgroundColor: "#fff",
                                        color: "#000",
                                        borderRadius: "5px",
                                        padding: "8px 20px",
                                        border: "1px solid #d9d9d9",
                                        cursor: "pointer"
                                    }}
                                >
                                    Reset
                                </button>
                            </div>
                        </div>
                            <div className="col-sm-4 mt-4" style={{ display: "flex", justifyContent: "flex-end" }}>
                            <button
                                type="button"
                                onClick={onClickCycleBtn}
                                style={{
                                    backgroundColor: "#93385D",
                                    color: "#fff",
                                    borderRadius: "5px",
                                    height: "36px",
                                    padding: "0 20px",
                                    border: "none",
                                    cursor: "pointer",
                                    display: "inline-flex",
                                    alignItems: "center"
                                }}
                            >
                                Generate Cycle Dates   

                        </button>
                        </div>
                    </form>

                    <div className="col-sm-12 p-0 pl-2 mt-6">
                        <div className="ag-theme-alpine" style={{ height: 500, width: "100%" }}>
                            <AgGridReact
                                rowData={rowData}
                                columnDefs={columnWithDefs}
                                defaultColDef={defaultColDef}
                                domLayout="normal"
                                onGridReady={onGridReady}
                                onFirstDataRendered={onFirstDataRendered}
                                suppressHorizontalScroll={false}
                                sideBar={sideBar}
                                statusBar={statusPanel}
                                pagination={true}
                                paginationPageSize={1000}
                                enableRangeSelection={true}
                                gridOptions={{
                                    suppressHorizontalScroll: false
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>

            {/* Slider for Cycle Button */}
            <div
                className={`stock-status-slider ${isSliderOpen ? "open" : ""} ${sliderCl}`}
                style={{ width: "25%" }}
            >
                <div className="slider-header-container d-flex justify-content-between">
                    <p className="m-0p">{sliderTitle}</p>
                    <p
                        className="m-0p"
                        style={{ cursor: "pointer" }}
                        onClick={onClickingSliderCloseIcon}
                    >
                        X&nbsp;&nbsp;&nbsp;
                    </p>
                </div>

                {sliderType === 2 && (
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            height: "100%",
                            overflowY: "auto",
                            padding: 5,
                        }}
                    >
                        <form style={{ flexGrow: 1, overflowY: "auto", padding: "10px" }} onSubmit={handleCycleSubmit}>

                            {/* Start Date */}
                            <div className="mb-1 mt-2" style={{ display: "flex", flexDirection: "column" }}>
                                <label style={{ fontSize: "13px", fontWeight: "400" }}>Start Date:</label>
                                <input
                                    type="date"
                                    id="wholesaleMonth"
                                    value={cycleStartDate}
                                    onClick={() => document.getElementById('wholesaleMonth').showPicker?.()}
                                    onChange={(e) => setCycleStartDate(e.target.value)}
                                    style={{
                                        padding: "7px",
                                        borderRadius: "5px",
                                        border: "1px solid #d9d9d9",
                                        width: "100%",
                                        marginBottom: "15px",
                                        cursor: "pointer",
                                    }}
                                />
                            </div>

                            {/* Destinations - PrimeReact MultiSelect */}
                            <div className="mt-2">
                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "5px" }}>
                                    <label style={{ fontSize: '13px', fontWeight: '400' }}>Select Destinations:</label>
                                </div>

                                <MultiSelect
                                    value={selectedDestinations}
                                    options={destinationOptions}
                                    onChange={(e) => setSelectedDestinations(e.value)}
                                    optionLabel="label"
                                    optionValue="value"
                                    filter
                                    maxSelectedLabels={1}
                                    display="chip"
                                    placeholder="Select destinations"
                                    style={{
                                        width: "100%",
                                        borderRadius: "5px",
                                        backgroundColor: "#fff",
                                        fontSize: "13px",
                                    }}
                                />

                            </div>

                            <div style={{ textAlign: "right", marginTop: "15px" }}>
                                <button
                                    className="btn btn-success"
                                    style={{
                                        color: "#fff",
                                        fontSize: "0.8rem",
                                        backgroundColor: "#93385D",
                                        padding: "8px 20px",
                                        border: "none",
                                        borderRadius: "5px",
                                        cursor: "pointer"
                                    }}
                                    type="submit"
                                    disabled={destinationOptions.length === 0}
                                >
                                    Generate Cycle Dates
                                </button>
                            </div>
                        </form>
                    </div>
                )}

            </div>

            <div className={`loader ${loadshow}`} style={{ zIndex: "1002" }}></div>
            <div className={`overlay-block ${overlayBlock}`}></div>
            <div
                className={"overly-block " + overlyBlock}
                onClick={hideOverlySlideBlock}
            ></div>
        </>
    );
};

const selectStyles = {
    control: (base) => ({
        ...base,
        padding: '1px',
        borderRadius: '5px',
        border: '1px solid #d9d9d9',
    }),
    singleValue: (base) => ({
        ...base,
        fontWeight: 'normal',
        color: '#333',
        fontSize: "12px"
    }),
    option: (base, state) => ({
        ...base,
        fontSize: "13px",
        fontWeight: state.isSelected ? 'normal' : 'normal',
    })
}

export default CycleDaysIndentation;